<template>
  <div class="chemotherapy">
    <Empty v-if="isEmpty" />
    <!-- <Screen /> -->
    <div class="list" v-for="(item, index) in listData" :key="index">
      <h1>{{ item.drug }}</h1>
      <div class="show-box"></div>
      <div class="gene-box">
        <div class="l">
          <div>
            <p>基因</p>
            <h2>{{ item.gene }}</h2>
          </div>
          <div>
            <p>检测结果</p>
            <h2>{{ item.genotypeResult }}</h2>
          </div>
          <div>
            <p>证据等级</p>
            <h3
              :style="{
                color: textColor[item.levelEvidence],
                background: bgColor[item.levelEvidence],
              }"
            >
              {{ item.levelEvidence }}
            </h3>
          </div>
        </div>
        <div class="r">
          <div>
            <p>检测位点</p>
            <h2>{{ item.dbsnpRs }}</h2>
          </div>
          <div>
            <p>类别</p>
            <h2 class="color-h">{{ item.classification }}</h2>
          </div>
        </div>
      </div>
      <div class="foo-box">
        <div>
          <p>用药提示</p>
          <h2>
            {{ item.medicationTips }}
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Screen from "./components/chemotherapy/screen.vue";
import { hlywData } from "@/api/reportQuery";
import { mapState } from "vuex";

export default {
  name: "chemotherapy",
  components: {
    Screen,
  },
  data() {
    return {
      isEmpty: false,
      listData: [{}],
      bgColor: {
        "Level 1A": "#E2F8FE",
        "Level 1B": "#EFEAFF",
        "Level 2A": "#FFF8DA",
        "Level 2B": "#FFECEF",
      },
      textColor: {
        "Level 1A": "#28D4E5",
        "Level 1B": "#7C67E6",
        "Level 2A": "#FFB026",
        "Level 2B": "#FF627F",
      },
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    this.getData(this.$route.query.fname, this.$route.query.fid);
    window.NativeCallJS = (res) => {
      let pars = JSON.parse(res);
      console.log(pars, "bbbbbb");
      this.getData(
        this.$route.query.fname,
        this.$route.query.fid,
        pars.classification,
        pars.drugList,
        pars.geneList,
        pars.levelEvidence
      );
    };
  },
  methods: {
    async getData(fname, fid, classification, drug, gene, levelEvidence) {
      try {
        let { data } = await hlywData({
          labOriginalSampleNo: fname,
          productCode: fid,
          classification: classification,
          drugs: drug,
          genes: gene,
          levelEvidence: levelEvidence,
        });
        this.listData = data;
        if (this.listData == "") {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      } catch (error) {}
    },
    sub() {
      alert(1);
    },
  },
};
</script>
<style lang="less" scoped>
.null-box {
  padding-top: 100px;
}
.chemotherapy {
  font-family: @family;
  padding: 16px;
  .list {
    background: @background_color;
    padding-bottom: 30px;
    border-radius: 10px;
    margin-bottom: 20px;
    .foo-box {
      padding-left: 24px;

      p {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 17px;
      }
      .color-h {
        color: #27ca8d;
      }
      h2 {
        font-size: 13px;
        font-weight: 500;
        color: #2f354d;
        padding-right: 24px;
        line-height: 22PX;
        word-break: break-all;
        text-align: justify;
        text-justify: newspaper;
      }
    }
    .gene-box {
      display: flex;
      padding-left: 24px;
      padding-top: 10px;
      p {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #a4a9bf;
        line-height: 17px;
      }
      .color-h {
        color: #27ca8d;
      }
      h2 {
        height: 18PX;
        font-size: 13px;
        font-weight: 500;
        color: #2f354d;
        line-height: 18PX;
      }
      h3 {
        font-size: 13px;
        font-weight: 400;
        line-height: 22px;
        width: 70px;
        height: 22px;
        text-align: center;
        border-radius: 4px;
        margin-top: 4px;
      }
      .l,
      .r {
        width: 50%;
        div {
          margin-bottom: 20px;
        }
      }
    }
    .show-box {
      height: 20px;
      background: linear-gradient(
        360deg,
        rgba(58, 74, 134, 0) 0%,
        rgba(58, 74, 134, 0.06) 100%
      );
    }
    h1 {
      height: 70px;
      font-size: 15PX;
      padding-left: 24px;
      font-family: @family;
      font-weight: 600;
      color: #2f354d;
      line-height: 70px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -7px;
        width: 3px;
        height: 14px;
        background: #2f354d;
        border-radius: 0px 2px 2px 0px;
      }
    }
  }
}
</style>
